import { Box, IconButton, SvgIcon } from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LogoEnte from "../assets/logo_ente.png";
import LogoMVM from "../assets/logo_mvm.svg";
import LogoPeniero from "../assets/logo_peniero.png";
import { useLocation } from "react-router-dom";
import Banner from "./Banner";

// Componente SVG para TikTok
const TikTokIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </SvgIcon>
);

export default function Footer() {

    const location = useLocation();

    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            py: '100px',
            gap: "100px"

        }}>
            {!['fotos-recorrido', 'villa-maria'].includes(location.pathname.split('/')[1]) && <Banner />}
            
            {/* Sección de Redes Sociales */}
            <Box sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: { xs: 2, md: 3 },
            }}>
                <IconButton
                    component="a"
                    href="https://www.instagram.com/anfivillamaria/?hl=es"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    sx={{
                        color: '#FFFFFF',
                        fontSize: { xs: '32px', md: '40px' },
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        },
                    }}
                >
                    <InstagramIcon sx={{ fontSize: 'inherit' }} />
                </IconButton>

                <IconButton
                    component="a"
                    href="https://www.facebook.com/AnfiVillaMaria/?locale=es_LA"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                    sx={{
                        color: '#FFFFFF',
                        fontSize: { xs: '32px', md: '40px' },
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        },
                    }}
                >
                    <FacebookIcon sx={{ fontSize: 'inherit' }} />
                </IconButton>

                <IconButton
                    component="a"
                    href="https://x.com/AnfiVillaMaria"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter/X"
                    sx={{
                        color: '#FFFFFF',
                        fontSize: { xs: '32px', md: '40px' },
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        },
                    }}
                >
                    <XIcon sx={{ fontSize: 'inherit' }} />
                </IconButton>

                <IconButton
                    component="a"
                    href="https://www.tiktok.com/@anfivillamaria"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="TikTok"
                    sx={{
                        color: '#FFFFFF',
                        fontSize: { xs: '32px', md: '40px' },
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'scale(1.2)',
                        },
                    }}
                >
                    <TikTokIcon sx={{ fontSize: 'inherit' }} />
                </IconButton>
            </Box>

            <Box sx={{
                width: '100%',
                display: 'flex',
                gap: { xs: '80px', md: '150px' },
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <img src={LogoMVM} alt="Logo MVM" style={{ width: '200px' }} onClick={() => window.location.assign("https://villamaria.gob.ar/")} />
                <img src={LogoEnte} alt="Logo Ente" style={{ width: '200px' }} />
                {location.pathname.includes('recorrido') && <img src={LogoPeniero} alt="Logo Ente" style={{ width: '250px' }} />}
            </Box>
        </Box>
    )
}